import { render } from "./Today.vue?vue&type=template&id=467ab854&scoped=true&ts=true"
import script from "./Today.vue?vue&type=script&lang=ts"
export * from "./Today.vue?vue&type=script&lang=ts"

import "./Today.vue?vue&type=style&index=0&id=467ab854&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467ab854"]])

export default __exports__